/**
 * External dependencies
 */
import { FC } from 'react';

/**
 * Internal dependencies
 */
import ClutchWidget from 'components/ClutchWidget';

type ClutchReviewsProps = {};

const ClutchReviews: FC<ClutchReviewsProps> = () => (
	<div className="clutch-reviews">
		<ClutchWidget
			reviews="59237,359230,348696,343956"
			type={12}
			height={300}
		/>
	</div>
);

export default ClutchReviews;
